import React from 'react';
import { useParams } from 'react-router-dom';
import { Dimmer, Loader, Message } from 'semantic-ui-react';
import { useSoftCreditPullReport } from 'hooks/api/useSoftCreditPullReport';
import Sidebar from '../SidebarContainer';

export const CreditReport: React.FC = () => {
  const { dealId }: { dealId: string } = useParams();
  const { isLoading, error, data } = useSoftCreditPullReport(dealId);

  const getPageContent = () => {
    if (isLoading) {
      return (
        <Dimmer active inverted>
          <Loader inverted content="Loading" />
        </Dimmer>
      );
    }

    if (error) {
      const apiErr = error.detail || error.title;
      const headerExplanation = apiErr ? `: ${apiErr}` : '';
      return (
        <Message negative>
          <Message.Header>
            {`Could not fetch credit report${headerExplanation}`}
          </Message.Header>
        </Message>
      );
    }

    // add a `key` to the iframe incase we refetch a fresh signed URL
    // changing just the `src` attribute of an iframe is considered a navigation, so
    // the back button on the browser will cause the *iframe* to go back. Using a unique
    // key per URL will create a fresh iframe element, avoiding this behavior
    // https://www.aleksandrhovhannisyan.com/blog/react-iframes-back-navigation-bug/
    return (
      <iframe
        data-testid="credit-report-iframe"
        key={data?.data.url}
        src={data?.data.url}
        title="Credit Report"
        width="800px"
        style={{
          border: 'none',
          flex: '1 1 0',
          margin: '32px',
        }}
      />
    );
  };

  return <Sidebar title="Credit Report">{getPageContent()}</Sidebar>;
};
